import React from "react"
import { Box, Typography } from "@mui/material"
import { colorByteToRgb, PALETTE_A } from "../utils/bluetooth"

// Placement role ids — see client/src/pages/constants.js.
export const ROLE_START = 12
export const ROLE_MIDDLE = 13
export const ROLE_FINISH = 14
export const ROLE_FOOT = 15

export const ROLE_OPTIONS = [
  { role: ROLE_START, label: "Start", byte: PALETTE_A.START },
  { role: ROLE_MIDDLE, label: "Middle", byte: PALETTE_A.MIDDLE },
  { role: ROLE_FOOT, label: "Foot", byte: PALETTE_A.FOOT },
  { role: ROLE_FINISH, label: "Finish", byte: PALETTE_A.FINISH },
]

export const roleRgb = (role) =>
  colorByteToRgb(ROLE_OPTIONS.find((o) => o.role === role)?.byte ?? 0)

const rgbCss = ([r, g, b]) => `rgb(${r}, ${g}, ${b})`

/**
 * Four hold-type swatches in a row, styled as a radio group. Presentational
 * only: the page reads `data-role` off the pressed element so a press here
 * can turn into a drag onto the board.
 */
export default function RoleBar({ value }) {
  return (
    <Box
      role="radiogroup"
      sx={{ display: "flex", gap: 1, width: "100%", touchAction: "none" }}
    >
      {ROLE_OPTIONS.map(({ role, label, byte }) => {
        const selected = role === value
        const rgb = colorByteToRgb(byte)
        const color = rgbCss(rgb)
        const tint = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.18)`
        return (
          <Box
            key={role}
            role="radio"
            aria-checked={selected}
            aria-label={label}
            data-role={role}
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.5,
              py: 1,
              borderRadius: 2,
              border: "2px solid",
              borderColor: selected ? color : "divider",
              bgcolor: selected ? tint : "transparent",
              cursor: "pointer",
              userSelect: "none",
              WebkitUserSelect: "none",
              WebkitTouchCallout: "none",
            }}
          >
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: color,
                bgcolor: selected ? color : "transparent",
                pointerEvents: "none",
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontWeight: selected ? 700 : 400,
                pointerEvents: "none",
              }}
            >
              {label}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}
